<form (submit)="handleSubmit($event)">
  <div class="flex items-center gap-4 px-6 pt-6 pb-5 border-b border-outline-variant">
    <div
      class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-container shrink-0"
    >
      <mat-icon class="text-on-primary-container text-[20px]! w-5! h-5!">badge</mat-icon>
    </div>
    <div>
      <h2 class="text-lg font-medium leading-tight">Upravit jméno</h2>
      <p class="text-sm text-on-surface-variant mt-0.5">Změňte jméno zobrazované v aplikaci</p>
    </div>
  </div>

  <mat-dialog-content>
    <div class="flex flex-col gap-5 pb-4">
      <app-form-field-wrapper fieldName="Jméno">
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            placeholder="Jan"
            autocomplete="given-name"
            [formField]="profileForm.firstName"
          />
          @if (profileForm.firstName().touched() && profileForm.firstName().invalid()) {
            <mat-error>{{ profileForm.firstName().errors()[0].message }}</mat-error>
          }
        </mat-form-field>
      </app-form-field-wrapper>

      <app-form-field-wrapper fieldName="Příjmení">
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            placeholder="Novák"
            autocomplete="family-name"
            [formField]="profileForm.lastName"
          />
          @if (profileForm.lastName().touched() && profileForm.lastName().invalid()) {
            <mat-error>{{ profileForm.lastName().errors()[0].message }}</mat-error>
          }
        </mat-form-field>
      </app-form-field-wrapper>
    </div>
  </mat-dialog-content>

  <app-dialog-error-bar [message]="submission.errorMessage()" />

  <mat-dialog-actions align="end" class="border-t border-outline-variant!">
    <button matButton type="button" [disabled]="submission.isSaving()" (click)="dialogRef.close()">
      Zrušit
    </button>
    <button matButton="filled" type="submit" [disabled]="submission.isSaving()">
      @if (submission.isSaving()) {
        Ukládám…
      } @else {
        Uložit
      }
    </button>
  </mat-dialog-actions>
</form>
